import { parsePeriodId } from '@artem-cbam-declarants/shared'
import { ReportingPeriodBasis, TableCell, TableRow } from '@/common'
import { SupplierEmissionsReport } from '@/features/suppliers/hooks/supplierEmissionsReport'
import useI18n from '@/shared/hooks/usei18n'
import { Button, IconButton } from '@/common'
import { TrashIcon } from '@/common/components/icons'
import { useEffect, useState } from 'react'
import useOrganizationDocuments from '@/shared/hooks/useOrganizationDocuments'
import CnCodeTag from '@/shared/components/CnCodeTag'

export default function SupplierEmissionsReportRow({
  report,
  basisForReportingPeriod,
  onEdit,
  onDeleteClick
}: {
  report: SupplierEmissionsReport
  basisForReportingPeriod: ReportingPeriodBasis
  onEdit: (report: SupplierEmissionsReport) => void
  onDeleteClick: () => void
}) {
  const { t, shortDateFormatter, dateLongFormatterMonthYear } = useI18n()
  const { generateDownloadUrl } = useOrganizationDocuments()
  const [url, setUrl] = useState<string>('')

  const getPeriodLabel = (periodId: string) => {
    const { startDate, endDate } = parsePeriodId(periodId)

    return basisForReportingPeriod === 'CALENDAR_YEAR'
      ? `${startDate.getFullYear()}`
      : `${dateLongFormatterMonthYear(startDate)} - ${dateLongFormatterMonthYear(endDate)}`
  }

  useEffect(() => {
    const fetchUrl = async () => {
      if (report.evidenceFileName) {
        const url = await generateDownloadUrl(report.evidenceFileName)
        if (url) {
          setUrl(url)
        }
      }
    }
    if (!url) {
      fetchUrl()
    }
  }, [generateDownloadUrl, report.evidenceFileName, url])

  return (
    <TableRow key={report.id}>
      <TableCell>{report.goods[0].goodsDescription}</TableCell>
      <TableCell>
        {report.evidenceFileName ? (
          <a
            href={url}
            download={report.evidenceFileName}
            className="text-blue-500 hover:underline"
          >
            {report.evidenceFileName}
          </a>
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell>
        {report.goods[0].cnCode ? <CnCodeTag cnCode={report.goods[0].cnCode} /> : '-'}
      </TableCell>
      <TableCell>{getPeriodLabel(report.periodId)}</TableCell>
      <TableCell>{shortDateFormatter(new Date(report.createdAt))}</TableCell>
      <TableCell align="right">
        <div className="flex items-center gap-2 justify-end">
          <Button variant="txt-default" onClick={() => onEdit(report)}>
            {t('supplierEmissionsReport:emissionReports.table.actions.edit')}
          </Button>
          <IconButton
            icon={<TrashIcon />}
            variant="txt-danger"
            sizeType="sm"
            onClick={onDeleteClick}
          />
        </div>
      </TableCell>
    </TableRow>
  )
}
